export default __webpack_public_path__ + "static/media/Node.abfaef34.png";